"use client";

import { useEffect } from "react";

/**
 * Starts a page-builder runtime in the browser once this component mounts,
 * and stops it on unmount. `start` is a dynamic `import()` of the runtime,
 * so it never runs during SSR; it may return the runtime's stop function.
 */
export function useClientRuntime(
  start: () => Promise<(() => void) | void>,
): void {
  useEffect(() => {
    let stop: (() => void) | void;
    let unmounted = false;
    void start().then((stopRuntime) => {
      if (unmounted) stopRuntime?.();
      else stop = stopRuntime;
    });
    return () => {
      unmounted = true;
      stop?.();
    };
  }, [start]);
}
